import { render } from "./component-gruz.vue?vue&type=template&id=1a684cfd"
import script from "./component-gruz.vue?vue&type=script&setup=true&lang=js"
export * from "./component-gruz.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-gruz.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a684cfd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a684cfd', __exports__)) {
    api.reload('1a684cfd', __exports__)
  }
  
  module.hot.accept("./component-gruz.vue?vue&type=template&id=1a684cfd", () => {
    api.rerender('1a684cfd', render)
  })

}


export default __exports__